import React, { useState, useEffect, useRef } from "react";
import { FiCheck, FiCopy } from "react-icons/fi";
import { RiChatAiLine } from "react-icons/ri";
import { CiGlobe } from "react-icons/ci";
import { BiAnalyse, BiCodeAlt, BiPencil } from "react-icons/bi";
import InnerAiMex from "./AiMex";
import InnerUserMex from "./UserMex";
import { Dropdown } from "react-bootstrap";
import { TbBrandAppleArcade, TbChartSankey } from "react-icons/tb";

const LLMChat = ({ userMessage, messages, isLoading, user_id, sendMessage, setUserMessage, setInternetActive, internetActive }) => {
    const lastMessageRef = useRef(null);

    useEffect(() => {
        if (lastMessageRef.current) {
            lastMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }, [messages]);

    const handleInput = (e) => {
        e.target.style.height = "auto"; // Reset height
        e.target.style.height = Math.min(e.target.scrollHeight, 250) + "px"; // Set new height up to 250px
    };

    const toggleInternet = () => {
        if (internetActive) {
            setInternetActive(false)
        } else {
            setInternetActive(true)
        }
    }

      // Handle block item click
      const handleBlockItemClick = (message) => {
        setUserMessage(message);
    }

    return (
        <div className="llm_container">
            <div className="main_llm_container">
                <div className="main_llm_cont">
                    {messages.length <= 0 ? (
                        <div className="no_mex_cont_llm">
                            <div className="no_mex_cont_llm_container">
                                <p className="main_mex_llm_welcome">Hi, I'm Erioon.</p>
                                <p className="main_mex_llm_subtitle">What are we building today?</p>
                                <div className="main_mex_llm_blocks">
                                    <div className="main_mex_llm_block_item" onClick={() => handleBlockItemClick("Create an arcade game with varying difficulty levels using React for the frontend and Python for the backend. The game should include user login and account management features, multiple levels of difficulty, and other engaging elements to enhance the gaming experience.")}>
                                        <i><TbBrandAppleArcade/></i>
                                        <p className="main_mex_llm_block_item_title">Build an arcade game with different levels.</p>
                                    </div>
                                    <div className="main_mex_llm_block_item" onClick={() => handleBlockItemClick("Develop an HR analysis tool that allows sending emails to employees and tracking their working hours. The tool should provide insights into employee productivity and work patterns.")}>
                                        <i><TbChartSankey/></i>
                                        <p className="main_mex_llm_block_item_title">Create a tool for HR analysis</p>
                                    </div>
                                    <div className="main_mex_llm_block_item" onClick={() => handleBlockItemClick("Build a secure file-sharing system that allows users to easily share documents through a simple, encrypted link. The system should ensure privacy and data protection during file transfers.")}>
                                        <i><BiCodeAlt/></i>
                                        <p className="main_mex_llm_block_item_title">Create a file sharing system</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            {messages.map((msg, index) => (
                                <div
                                    key={index}
                                    className={`${msg.sender === "user" ? "user_mex" : "ai_mex"}`}
                                >
                                    {console.log(msg)}
                                    <div className="mex_cont">
                                        {msg.sender === "user" ? (
                                            <InnerUserMex text={msg.text} />
                                        ) : (
                                            <InnerAiMex text={msg.text} isLoading={isLoading} />
                                        )}
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                    <div ref={lastMessageRef} className="special_cont"></div>
                </div>
            </div>
            <div className={`footer_llm_container`}>
                <div className="input_btn_cont">
                    <textarea
                        className="llm_input"
                        value={userMessage}
                        onInput={handleInput}
                        onChange={(e) => setUserMessage(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                sendMessage();
                            }
                        }}
                        placeholder={internetActive ? "Create a software with containing the best cooking articles..." : "Build an arcade game with different levels..."}
                    />

                    <div className="action_btn_llm_cont">
                        <div className="action_btn_llm_cont_items">
                            {/* <i className={`action_btn_llm ${internetActive ? "action_btn_llm_active" : ""}`} onClick={toggleInternet}>
                                <CiGlobe />
                            </i> */}
                            <i className={`action_btn_llm`}>
                                <CiGlobe />
                            </i>
                            {/* <Dropdown>
                                <div className="property_btn_action_toggle">
                                    <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                        <i><RiChatAiLine /></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="custom-dropdown-menu">
                                        <Dropdown.Item
                                            className="drop_down_item"
                                        // onClick={() => handleDeleteClick(api._id)}
                                        >
                                            OpenAI - ChatGPT
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            className="drop_down_item"
                                        // onClick={() => handleDeleteClick(api._id)}
                                        >
                                            Anthropic - Sonnet
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            className="drop_down_item"
                                        // onClick={() => handleDeleteClick(api._id)}
                                        >
                                            DeepSeek - AI
                                        </Dropdown.Item>

                                    </Dropdown.Menu>
                                </div>
                            </Dropdown> */}
                            <i>
                                <RiChatAiLine />
                            </i>
                        </div>
                        <button className="llm_chat_btn" onClick={sendMessage} disabled={isLoading}>
                            <i className="fa-solid fa-arrow-up"></i>
                        </button>
                    </div>
                </div>
                {/* <p className="footer_mex_llm">LLMs can make mistakes. Consider verifying important information.</p> */}
            </div>
        </div>
    );
};

export default LLMChat;
